<!-- START Top Navbar-->
<nav class="navbar topnavbar" role="navigation">
    <!-- START Left navbar with hamburger menu-->
    <ul class="navbar-nav flex-row align-items-center">
        <!-- Brand logo after hamburger -->
        <li class="nav-item">
            <a class="navbar-brand" href="#/">
                <div class="brand-logo">
                    <div class="brand-icon">
                        <img class="img-fluid" src="assets/img/newlogo.png" alt="" />
                    </div>
                    <div class="brand-text">
                        Chat Starter &amp; ChatAI Admin
                    </div>
                </div>
                <div class="brand-logo-collapsed">
                    <img class="img-fluid" src="assets/img/newlogo.png" alt="Chat Starter &amp; ChatAI Admin" />
                </div>
            </a>
        </li>
        <!-- START User avatar toggle-->
        <!--<li class="nav-item d-none d-md-block">-->
            <!-- Button used to collapse the left sidebar. Only visible on tablet and desktops-->
            <!--<a  class="nav-link" (click)="toggleUserBlock($event)">
                <em class="icon-user"></em>
            </a>
        </li>-->
        <!-- END User avatar toggle-->
        <!-- START lock screen-->
        <!--<li class="nav-item d-none d-md-block">
            <a class="nav-link"  title="Lock screen" [routerLink]="'/lock'">
                <em class="icon-lock"></em>
            </a>
        </li>-->
        <!-- END lock screen-->
    </ul>
    <!-- END Left navbar-->
    <!-- START Right Navbar-->
    <ul class="navbar-nav flex-row ml-auto">
        <!-- Search icon-->
        <!--<li class="nav-item">
            <a class="nav-link" (click)="openNavSearch($event)">
                <em class="icon-magnifier"></em>
            </a>
        </li>-->
        <!-- Fullscreen (only desktops)-->
        <!--<li class="nav-item d-none d-md-block">
            <a class="nav-link" #fsbutton (click)="toggleFullScreen($event)">
                <em class="fa fa-expand"></em>
            </a>
        </li>-->
      <li class="nav-item">
        <div class="nav-link nav-text" *ngIf="orgs && orgs.length === 1">
          <span>{{selectedOrg.name}}</span>
          <span class="tier-badge d-inline-flex align-items-center" [ngClass]="getTierBadgeClass()" [title]="getTierDisplayName()">
            <i class="d-flex align-items-center me-1" [ngClass]="getTierIcon()"></i>
            <span class="tier-text">{{getTierDisplayName()}}</span>
          </span>
        </div>
        <div class="nav-link nav-text" *ngIf="orgs && orgs.length > 1">
          <select *ngIf="selectedOrg" class="nacustom-select custom-select-sm" (change)="changeOrg($event)" [(ngModel)]="selectedOrg" [compareWith]="compareOrgs">
            <option *ngFor="let o of orgs" [ngValue]="o">{{o.name}}</option>
          </select>
          <span class="tier-badge d-inline-flex align-items-center" [ngClass]="getTierBadgeClass()" [title]="getTierDisplayName()">
            <i class="d-flex align-items-center me-1" [ngClass]="getTierIcon()"></i>
            <span class="tier-text">{{getTierDisplayName()}}</span>
          </span>
        </div>
      </li>
        <!-- START Alert menu-->
        <li class="nav-item dropdown dropdown-list" dropdown>
            <a class="nav-link alerts-link dropdown-toggle dropdown-toggle-nocaret" dropdownToggle>
                <em class="icon-bell"></em>
                <span *ngIf="activeAlerts() > 0" class="badge badge-danger">{{activeAlerts()}}</span>
            </a>
            <!-- START Dropdown menu-->
            <div *dropdownMenu class="dropdown-menu dropdown-menu-right animated flipInX">
              <div *ngIf="activeAlerts() <= 0" class="dropdown-item">
                <!-- START list group-->
                <div class="list-group">
                  <div class="list-group-item list-group-item-action">
                    <span class="d-flex align-items-center">
                      <span class="text-sm">No active notifications</span>
                    </span>
                  </div>
                </div>
                <!-- END list group-->
              </div>
              <div *ngIf="activeAlerts() > 0" class="dropdown-item">
                <!-- START list group-->
                <div class="list-group">
                  <div *ngFor="let a of alerts" class="list-group-item list-group-item-action">
                    <div class="media">
                      <div class="align-self-start mr-2">
                        <em [ngClass]="['fa', a.icon || 'fa-bell', 'fa-2x']" [style.color]="a.color" ></em>
                      </div>
                      <div class="media-body">
                        <p class="m-0">{{a.type}}</p>
                        <p class="m-0 text-muted text-sm">{{a.subject}}</p>
                      </div>
                    </div>
                  </div>
                  <!-- list item-->
                  <!--<div class="list-group-item list-group-item-action">
                    <div class="media">
                      <div class="align-self-start mr-2">
                        <em class="fa fa-envelope fa-2x text-warning"></em>
                      </div>
                      <div class="media-body">
                        <p class="m-0">New e-mails</p>
                        <p class="m-0 text-muted text-sm">You have 10 new emails</p>
                      </div>
                    </div>
                  </div>-->
                  <!-- list item-->
                  <!--<div class="list-group-item list-group-item-action">
                    <div class="media">
                      <div class="align-self-start mr-2">
                        <em class="fa fa-tasks fa-2x text-success"></em>
                      </div>
                      <div class="media-body">
                        <p class="m-0">Pending Tasks</p>
                        <p class="m-0 text-muted text-sm">11 pending task</p>
                      </div>
                    </div>
                  </div>-->
                  <!-- last list item-->
                  <div class="list-group-item list-group-item-action">
                    <span class="d-flex align-items-center">
                      <span class="text-sm">{{activeAlerts()}} active notification{{activeAlerts() !== 1 ? 's' : ''}}</span>
                      <a class="text-sm text-muted ml-auto" style="cursor:pointer" (click)="clearAlerts(); $event.stopPropagation()">Clear all</a>
                    </span>
                  </div>
                </div>
                <!-- END list group-->
              </div>
            </div>
            <!-- END Dropdown menu-->
        </li>
        <!-- END Alert menu-->
        <!-- START About button-->
        <li class="nav-item">
            <a class="nav-link about-link" title="About" (click)="openAbout(); $event.stopPropagation()">
                <em class="icon-question"></em>
            </a>
        </li>
        <!-- END About button-->
        <!-- START Beamer news button-->
        <li class="nav-item">
            <a id="beamerNewsIcon" class="nav-link beamer-link" title="What's New" aria-label="What's New" role="button" tabindex="0" (click)="openBeamer()">
                <em class="far fa-newspaper"></em>
            </a>
        </li>
        <!-- END Beamer news button-->
        <!-- START Right Panel Toggle-->
        <li class="nav-item" *ngIf="isRightPanelAvailable()">
            <a class="nav-link" title="Toggle Right Panel" (click)="toggleRightPanel($event)">
                <img src="assets/img/orion.png" alt="Orion" style="height: 20px; width: auto;">
            </a>
        </li>
        <!-- END Right Panel Toggle-->
        <!-- START Offsidebar button-->
        <li class="nav-item">
            <!--<a class="nav-link" (click)="toggleOffsidebar(); $event.stopPropagation()">
                <em class="icon-notebook"></em>
            </a>-->
           <a class="nav-link logout-link" title="Log out" (click)="logout(); $event.stopPropagation()">
            <em class="icon-logout"></em>
          </a>
       </li>
        <!-- END Offsidebar menu-->
    </ul>
    <!-- END Right Navbar-->

    <app-navsearch [visible]="getNavSearchVisible()" (onclose)="setNavSearchVisible(false)"></app-navsearch>

</nav>
<!-- END Top Navbar-->

<app-about-dialog></app-about-dialog>
